import { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import ButtonRow from "../../../configuration/shared/ButtonRow/ButtonRow";
import FileRow from "../../../configuration/shared/FileRow/FileRow";
import axios from "../../../../axios";


class EntryModal extends Component {

  state = {
    chosenFile: null,
    selectedFileName: null,
  }

  pageOptions = [
    { value: "router", label: "KNX IoT Router - downloads" },
    { value: "lora-gateway", label: "LoRa Gateway - downloads" }
  ]
  iconOptions = [
    { value: "document", label: "Document" },
    { value: "package", label: "Package" }
  ]

  componentDidMount() {

    // Load entry into state
    this.setState({ ...this.props.download })
  }

  updateHandler = () => {

    // Check for valid file
    if (this.state.chosenFile === null && this.props.createMode) {
      alert("Please choose a file.")
      return
    }

    // Sanitze other fields
    if (!this.state.filename) { return alert("Please enter a valid filename" )}
    if (!this.state.page) { return alert("Please select a page" )}
    if (!this.state.icon) { return alert("Please select an icon" )}
    if (this.state.filename === "Downloads.json") { return alert("Illegal filename, please choose another one.") }

    // Construct the entry
    let entry = { _id: this.state._id, page: this.state.page, icon: this.state.icon, name: this.state.name, filename: this.state.filename, position: this.state.position, lastUpdated: this.state.lastUpdated }
    
    // Post to the backend
    axios.post("/downloads/update", entry).then(() => {

      // In create mode, also upload the file at creation time
      if (this.props.createMode) {

        // Upload the file to the backend filesystem
        this.uploadFile(this.state.chosenFile, this.state.filename, this.state.page, () => {

          // Close the modal once this finishes
          this.props.closeModal()
        })

      } else {

        // Close the modal, any file updates were done immediately
        this.props.closeModal()
      }
    })
  }

  deleteHandler = () => {

    // Check for valid ID
    if (!this.state._id) { return }
 
    // Delete from the backend
    axios.delete("/downloads/" + this.state._id).then(() => {
              
      // Close the modal
      this.props.closeModal()

    }).catch(err => {
      let message = err.toString()
      if (err.response) {
        if (typeof err.response.data === "object") {
          message = message + "\r\n" + JSON.stringify(err.response.data)
        }
      }
      alert(message)
    })
  }


  // MARK: - File handlers

  handleChosenFile = (event) => {
    const file = event.target.files[0]
    if (!file) return

    // Track the selected filename for visual feedback
    this.setState({ selectedFileName: file.name })

    if (this.props.createMode) {

      // In create mode, save to state and upload once the entry is created
      this.setState({ chosenFile: file })

    } else {

      // In edit mode, upload immediately (to avoid uploading a new file and rename at the same time)
      this.uploadFile(file, this.props.download.filename, this.props.download.page, () => {

        // Let the user know the upload was successful
        alert("File has been successfully replaced on the file system.")
      })
    }
  }

  uploadFile = (file, filename, page, callback) => {

    // Read file from host file system
    let reader = new FileReader()
    reader.addEventListener("load", function() {

      // Process result
      let fileContents = reader.result.split("base64,")[1]

      // Prepare request
      let body = { file: fileContents, filename, page }

      console.log(body)

      // Upload the base64-encoded contents to the backend
      axios.post("/downloads/file/upload", body).then(() => {
        
        // Callback if provided, to close modal upon creation
        callback?.()

      }).catch(err => {
        let message = err.toString()
        if (err.response) {
          if (typeof err.response.data === "object") {
            message = message + "\r\n" + JSON.stringify(err.response.data)
          }
        }
        alert(message)
      })

    }, false)
    reader.readAsDataURL(file)
  }

  downloadFile = () => {

    // Only allow valid filenames
    if (!this.props.download.filename) { return }

    // Download the original file
    const link = document.createElement("a")
    link.href = `https://gateway.allorado.io/${this.props.download.page}/${this.props.download.filename}`
    link.download = this.props.filename
    link.click()
  }


  render() {

    // Calculate if anything changed
    let modified = Object.entries(this.props.download).some(([key, propsVal]) => this.state[key] !== propsVal)

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={this.props.createMode ? "Add download" : "Edit download"}
      >
        <SelectRow
          title="Page"
          firstRow ultrawide
          increasedPadding
          value={this.state.page}
          onChange={(val) => this.setState({ page: val.value })}
          options={this.pageOptions}/>
        <SelectRow
          title="Icon"
          ultrawide
          increasedPadding
          value={this.state.icon}
          onChange={(val) => this.setState({ icon: val.value })}
          options={this.iconOptions}/>
        <InputRow
          title="Visible name"
          ultrawide enabled
          placeholder="E.g. Router datasheet"
          value={this.state.name}
          onChange={(event) => this.setState({ name: event.target.value})}/>
        <InputRow
          title="File name"
          ultrawide enabled 
          value={this.state.filename}
          placeholder={"E.g. router-datasheet.pdf"}
          onChange={(event) => this.setState({ filename: event.target.value })}/>
        <InputRow
          title="Position"
          ultrawide enabled
          value={this.state.position}
          placeholder={"E.g. 2"}
          onChange={(event) => this.setState({ position: event.target.value })}/>
        <InputRow
          title="Last updated"
          ultrawide enabled
          value={this.state.lastUpdated}
          placeholder={"E.g. 20-11-2025"}
          onChange={(event) => this.setState({ lastUpdated: event.target.value })}/>

        <ButtonRow
          title="View file"
          body="Download file"
          show={!this.props.createMode}
          onClick={this.downloadFile}/>
        <FileRow
          title={this.props.createMode ? "Upload file" : "Replace file"}
          body="Choose file"
          inputId="downloadEntryFileInput"
          selectedFileName={this.state.selectedFileName}
          onClick={this.handleChosenFile}/>

        <ModalActions>
          {modified ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!this.props.createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.updateHandler}>
                {this.props.createMode ? "Create" : "Update"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
              {!this.props.createMode && <DeleteButton onClick={this.deleteHandler}/>}
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default EntryModal;
